import { render } from "./LampView.vue?vue&type=template&id=f5b2ee28"
import script from "./LampView.vue?vue&type=script&lang=js"
export * from "./LampView.vue?vue&type=script&lang=js"

import "./LampView.vue?vue&type=style&index=0&id=f5b2ee28&lang=css"
script.render = render

export default script